import {
    CREATE_API_KEY,
    CREATE_API_KEY_FAILURE,
    CREATE_API_KEY_MODAL_SUCCESS,
    CREATE_API_KEY_SUCCESS,
} from 'store/actions/types';

export const createApiKey = (payload) => {
    return {
        type: CREATE_API_KEY,
        payload: payload,
    };
};

export const createApiKeyFailure = (error) => {
    return {
        type: CREATE_API_KEY_FAILURE,
        error: error,
    };
};

export const createApiKeySuccess = (response) => {
    return {
        type: CREATE_API_KEY_SUCCESS,
        response: response,
    };
};

export const createApiKeyModalSuccess = () => {
    return {
        type: CREATE_API_KEY_MODAL_SUCCESS,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/apiKeys/createApiKeys.js